module.exports = __webpack_public_path__ + "static/media/file-excel.c5fb8d2c.svg";